var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Badge',{attrs:{"text":_vm.config.label,"color":_vm.config.bg,"textColor":_vm.config.text}})}
var staticRenderFns = []

export { render, staticRenderFns }